"use strict";

exports.__esModule = true;
exports.TicketTypesListView = TicketTypesListView;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
var _Core = require("../../Core");
var _System = require("../../../System");
var _TicketTypeListContext = require("../TicketTypeListContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ListViewWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TicketTypesListView__ListViewWrapper",
  componentId: "sc-oo8b3-0"
})(["width:100%;height:100%;overflow-y:auto;"]);
var ListItemHeaderWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TicketTypesListView__ListItemHeaderWrapper",
  componentId: "sc-oo8b3-1"
})(["width:100%;height:100%;display:inline-flex;"]);
var ColorBlock = _styledComponents["default"].div.withConfig({
  displayName: "TicketTypesListView__ColorBlock",
  componentId: "sc-oo8b3-2"
})(["border:solid 1px ", ";width:20px;height:20px;border-radius:5px;margin-right:10px;"], (0, _Theme.val)("ButtonBackground"));
function TicketTypesListView() {
  var ticketTypes = _react["default"].useContext(_TicketTypeListContext.TicketTypeListContext);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(ListViewWrapper, null, /*#__PURE__*/_react["default"].createElement(_Core.ListView, null, ticketTypes.getFiltered().map(function (ticketType) {
    return /*#__PURE__*/_react["default"].createElement(_Core.ListItemView, {
      key: ticketType.id
    }, /*#__PURE__*/_react["default"].createElement(_Core.ListItemViewLink, {
      to: (0, _System.getScreenURL)("UpdateTicketType", {
        id: ticketType.id
      })
    }, /*#__PURE__*/_react["default"].createElement(ListItemHeaderWrapper, null, /*#__PURE__*/_react["default"].createElement(ColorBlock, {
      style: {
        background: ticketType.color
      }
    }), /*#__PURE__*/_react["default"].createElement(_Core.ListItemHeading, {
      level: 4
    }, ticketType.value))));
  }))));
}